import React from "react";
import { Wrapper, TagColors, Icon } from "./components";
import InfoIcon from "assets/images/info-tooltip-circle.png";
import InfoIconDebt from "assets/icons/info-tooltip-deuda.svg";
import InfoIconShares from "assets/icons/info-tooltip-acciones.svg";
import InfoIconConvertibleNote from "assets/icons/info-tooltip-notaconvertible.svg";
import { BusinessLines } from "lib/models";

type Props = {
  icon?: JSX.Element | boolean;
  background: TagColors | string;
  title: string;
  color?: TagColors | string;
  spacing?: boolean;
  tooltip?: string;
  testId?: string;
  forceCenter?: boolean;
  onclick?: any;
  businessLine?: string;
};

const businessLineIcons: Record<string, string> = {
  [BusinessLines.Debt]: InfoIconDebt,
  [BusinessLines.Shares]: InfoIconShares,
  [BusinessLines.ConvertibleNote]: InfoIconConvertibleNote
};

export const Tag = ({
  icon,
  background,
  title,
  color,
  spacing,
  tooltip,
  businessLine
}: Props) => {
  const defaultIconSrc =
    (businessLine && businessLineIcons[businessLine]) || InfoIcon;

  return (
    <Wrapper
      background={background}
      color={color}
      data-testid={tooltip}
      spacing={spacing}
      data-tip={`tag-${tooltip}`}
      data-for={`tag-${tooltip}`}
    >
      {title}
      {icon && (
        <Icon>
          {typeof icon === "boolean" ? (
            <img src={defaultIconSrc} data-testid="tag-default-icon" />
          ) : (
            icon
          )}
        </Icon>
      )}
    </Wrapper>
  );
};
